import type {PageCollectionItemBase} from "@nuxt/content";
import {getFileNameFromStem} from "~/utils/get-filename-from-stem.function";

export const usePage = () => {
    const pageIndexSlug: string = 'index';
    const getIndex = (pages: PageCollectionItemBase[]): PageCollectionItemBase | undefined => {
        return pages.find(p => getFileNameFromStem(p.stem) === pageIndexSlug)
    }
    const getAllButIndex = (pages: PageCollectionItemBase[]): PageCollectionItemBase[] => {
        return pages.filter(p => getFileNameFromStem(p.stem) !== pageIndexSlug)
    }
    const getCurrentPage = (pages: PageCollectionItemBase[], routeSlug: string): PageCollectionItemBase | undefined => {
        return pages.find(p => p.path.includes(routeSlug));
    }
    return {
        getIndex,
        getAllButIndex,
        getCurrentPage,
    }
}